<script setup lang="ts">
const items = [
  {
    title: 'Followup Otomatis & Personal',
    description: 'Pesan dikirim otomatis, tapi tetap hangat dan ramah.',
    icon: 'material-symbols:person-add-outline'
  },
  {
    title: 'Kurangi Paket Gagal Kirim',
    description: 'Pembeli cepat merespons konfirmasi alamat.',
    icon: 'material-symbols:local-shipping-outline'
  },
  {
    title: 'Dorong Repeat Order',
    description:
      'Pengalaman pelanggan lebih positif, peluang repeat order meningkat.',
    icon: 'material-symbols:move-down'
  },
  {
    title: 'Hemat Waktu Tim CS',
    description: 'Semua pesan berjalan otomatis sesuai status pengiriman.',
    icon: 'material-symbols:timer-outline'
  },
  {
    title: 'Naikkan Reputasi Brand',
    description:
      'Komunikasi cepat = pelanggan percaya dan merekomendasikan toko kamu.',
    icon: 'material-symbols:trending-up'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Lebih dari Sekadar Notifikasi, Ini Investasi Loyalitas Pelanggan"
    hero-image="/images/wafu-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
